const state = {
  records: {},
};

const getters = {
  getActiveImports: $state => {
    return Object.values($state.records).filter(
      record =>
        record.status === 'processing' ||
        record.status === 'completed' ||
        record.status === 'failed'
    );
  },
};

const actions = {
  updateProgress({ commit }, data) {
    commit('SET_IMPORT_PROGRESS', data);
    // Automatically dismiss completed or failed ones after a few seconds
    if (data.status === 'completed' || data.status === 'failed') {
      setTimeout(() => {
        commit('REMOVE_IMPORT', data.id);
      }, 5000);
    }
  },
};

const mutations = {
  SET_IMPORT_PROGRESS($state, data) {
    $state.records[data.id] = {
      ...($state.records[data.id] || {}),
      ...data,
    };
  },
  REMOVE_IMPORT($state, id) {
    delete $state.records[id];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
